import { useState, useEffect } from 'react';

const usePreloader = (filePaths) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadFiles = async () => {
      try {
        // Запускаем загрузку файлов
        await Promise.all(
          filePaths.map((path) => fetch(path, { method: 'HEAD' }))
        );
      } catch (error) {
        console.error('Error loading files:', error);
      } finally {
        // Минимальная задержка в 1 секунду
        setTimeout(() => {
          setIsLoading(false);
        }, 1000); // 1 секунда минимальной задержки
      }
    };

    loadFiles();
  }, [filePaths]);

  return isLoading;
};

export default usePreloader;
